import React, { useEffect, useRef, useState } from 'react';
import { Grid, Autocomplete, Typography, TextField} from '@mui/material';
import Select from 'react-select';
import { connect } from 'react-redux';
import * as menuActions from '../../store/actions/breadcrumb';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import DefaultTable from '../../components/MainTableNested';
import TableCell from '@mui/material/TableCell';
import appConfig from "../../config/appConfig";
import SkeletonGridLoader from '../../components/SkeletonGridLoader';
import * as auditActions from '../../store/actions/auditLog';
import { MultiSelect } from "react-multi-select-component";
import FormControl from '@mui/material/FormControl';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { useLogout } from '../../components/Utils';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import moment from 'moment';
import FilterListIcon from '@mui/icons-material/FilterList';
import { CalculateUTCTzToUserTz,CalculateUserTzToUTCTz, splitDate, formatDTADate, splitTime } from '../../components/Utils';
import { endOfDay, startOfDay } from 'date-fns';


const dropDownlistCss = { mt: 1, mb: 1, borderRadius: "5px", border: `1px solid ${appConfig.colors.darkblue}`, background: "#fcfcfb", width: "100%", '.MuiAutocomplete-input': { height: "5px" } };
const datePropDownCss = { mt: 1, mb: 1, borderRadius: "5px", background: "#fcfcfb", width: "100%", '.MuiAutocomplete-input': { height: "5px", outline: "none" } };
const gridItemCss = { '&.MuiGrid-item': { pt: 0, pl: 2, pr: 2} };

const mb = { marginBottom: 0, fontWeight: "bold", color: appConfig.colors.darkgray };

const AuditLog = ({ setBreadcrumb, fetchAuditLogList, auditLogDetails, fetchAuditUserList, auditUserList }) => {
  const { t } = useTranslation('common');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  
  const navigate = useNavigate();
  const onLogout = useLogout();
  const handleToggle = () => {
    setIsFilterOpen(!isFilterOpen); // Toggle between true and false
  };
  const pageOptions = [
    {
        label: t("Business Units And Locations"),
        value: "BusinessUnitsAndLocations",
    },  {
        label: t("User Management"),
        value: "UserManagement",
    },  {
        label: t("Charitable Activity"),
        value: "CharitableActivity",
    }, {
      label: t("User Self Registration"),
      value: "UserSelfRegistration",
    }, {
      label: t("User Profile"),
      value: "UserProfile",
    }
    ]
    const byChangeOptions = [
      {
          label: t("Create"),
          value: "Create",
      },  {
          label: t("Update"),
          value: "Update",
      },  {
          label: t("Delete"),
          value: "Delete",
      }
      ];

  const isMounted = useRef(false);
  const params = useLocation();
  const [filterList, setFilterList] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState([]);
  const [userList, setUserList] = useState();
  const [selectedByChange, setSelectedByChange] = useState([]);
  const [byName, setByName] = useState('');
  const debounceTimeout = useRef(null);
  const [activityName, setActivityName] = useState('');
  const [auditListDetails, setAuditListDetails] =  useState();
  const [pagination, setPagination] = useState({ limit: 10, offset: 1 });
  const [businessUnitFilter, setBusinessUnitFilter] = useState(params?.state && params?.state?.dropdownSelected ? params?.state?.dropdownSelected : { key: 'All', value: "all" });
  const [selected, setSelected] = useState(null);
  const [sortValue, setSortValue] = useState({sortBy:"modifiedTime", sortOrder: "desc"});
  const [searchText, setSearchText] = useState("");

  
  const [filterValues, setFilterValues] = useState();
  useEffect(()=>{
    const filtervalue1 =  {
        startDate: '',
        endDate: '',
        filterByPage: setSelectedPage([]),
        filterByChange: [],
        filterByName: ''
      }
      setFilterValues(filtervalue1);
      fetchAuditLogList(10, 1, filtervalue1);
  },[])
  
  useEffect(() => {
    isMounted.current = true;
    fetchAuditLogList(pagination.limit, pagination.offset, filterValues);
    // fetchAuditUserList();
  }, [JSON.stringify(pagination), businessUnitFilter,JSON.stringify(sortValue)])
  
  useEffect(()=>{
      if(auditLogDetails && auditLogDetails?.auditLog && auditLogDetails?.status === 200){
        const data = auditLogDetails?.auditLog;
        setAuditListDetails({data:data})
      } else if (auditLogDetails && auditLogDetails?.status === 401) {
        onLogout();
      }
  },[auditLogDetails])
  useEffect(()=>{
    if(auditUserList && auditUserList?.auditUserList && auditUserList?.status === 200){
      const data = auditUserList?.auditUserList;
      const namesArray =
      data?.map(item => ({
        value: item.email,
        label:  item.name
      }));
      setUserList(namesArray)
    } else if (auditUserList && auditUserList?.status === 401) {
      onLogout();
    }
},[auditUserList])

  const defaultFilter = pageOptions?.map(item => item.value);
  const defaultByChangeFilter = byChangeOptions?.map(item => item.value);
  const debounceSearch = (query) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      fetchAuditUserList(query);
    }, 300);
  };
  const handleInputChange = (newValue) => {
    if(newValue.length > 0) {
      debounceSearch(newValue);
    }
  };
  const handlePageChange = (selectedOptions) => {
    setSelectedPage(selectedOptions);
  };
  const handleByChange = (selectedOptions) => {
    setSelectedByChange(selectedOptions);
  };
  const handleByNameChange = (value) => {
    if (value === null) {
      setUserList([])
    } 
    setByName(value); 
  };
  const { handleSubmit } = useForm();

  useEffect(() => {
    setBreadcrumb(t('Audit Log'))
    if (params.state && params.state.dropdownSelected) {
      setBusinessUnitFilter(params.state.dropdownSelected);
    }
  }, [params]);
  const handlePagination = (limit, offset) => {
    setPagination({ limit, offset })
  }
  const onSubmit = () => {
    const filterValues2 = {
      filterByPage: selectedPage.length === pageOptions.length ? [] : selectedPage || pageOptions?.map(item => item.value),
      filterByChange: selectedByChange.length === byChangeOptions.length ? [] : selectedByChange || byChangeOptions?.map(item => item.value),
      filterByName: byName?.value || '',
      startDate: fromDate ? CalculateUserTzToUTCTz(startOfDay(fromDate)).toISOString() : '',
      endDate: toDate ? CalculateUserTzToUTCTz(endOfDay(toDate)).toISOString() : '',
    }
    setFilterValues(filterValues2)
    setPagination({ limit: pagination.limit, offset: 1 })
    fetchAuditLogList(10, 1, filterValues2);
  };
  const onClear = () => {
    const filterInitValues = {
        startDate: '',
        endDate: '',
        filterByPage: setSelectedPage([]),
        filterByChange: [],
        filterByName: ''
      }
    setSelectedPage([]);
    setUserList([]);
    setSelectedByChange([]);
    setFromDate('');
    setToDate('');
    setByName('');
    setSelected(null);
    setFilterValues(filterInitValues)
    fetchAuditLogList(10, 1, filterInitValues, searchText);
  }
  const headers = [
    { name: t('Date & Time')},
    { name: t('User')},
    { name: t('Screen')},
    { name: t('Change')},
    { name: t('Identifier')},
    { name: t('Change log')}
    ];
    const auditTableData = auditListDetails?.data?.map((log, index) => ({
    id: (index + 1).toString(),
    col1: moment(CalculateUTCTzToUserTz(log?.timestamp)).format('M/D/YYYY, h:mm:ss A'),
    col2: log?.email ? `${log?.name} (${log?.email})` : log?.name,
    col3: t(log?.displayNameForPage),
    col4: t(log?.change),
    col5: log?.identifier,
    changeLog: log?.changeLogDetails
    }));

    const accessor = ['col1', 'col2','col3', 'col4','col5'];
    const loadRowDetails = <div>Row details content here</div>;


  return (
    <div  style={{paddingRight: 10}}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6}>
          <h1 className='page-heading' ><b>{t("Audit Log")}</b></h1>
        </Grid>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6} sx={{textAlign: {xs:"left", sm:"right", lg:"right", xl:"right",md:"right"}}}>
          <div onClick={handleToggle} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', float: 'right', marginBottom: 10, fontFamily: appConfig?.fontfamily }}>
                <IconButton>
                <FilterListIcon style={{ color: '#000' }}  />
                </IconButton>
                <b>{isFilterOpen ? t('hideFilters') : t('showFilters')}</b>
            </div>
        </Grid>
      </Grid>
      <hr className='blue-border mb-30' />
     
      <div className='filter-container'>
        {isFilterOpen && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} style={{alignItems: 'flex-end'}}>
                    <Grid  item  xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                        <p style={mb}>{t("From Date")}</p>
                        <FormControl sx={datePropDownCss} style={{height: 41}}>
                        <DatePicker
                                // {...field}
                                // sx={textboxCss}
                                style={{marginBottom:0,  height: 40}}
                                className='input-text-box1 mt-0' 
                                onChange={(date) => setFromDate(date)} 
                                value={fromDate}
                                dayPlaceholder='DD'
                                monthPlaceholder='MM'
                                yearPlaceholder='YYYY'
                            />
                        </FormControl>
                        </Grid>
                        <Grid  item  xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                        <p style={mb}>{t("To Date")}</p>
                        <FormControl sx={datePropDownCss}>
                        <DatePicker
                                className='input-text-box1 mt-0' 
                                onChange={(date) => setToDate(date)} 
                                value={toDate}
                                dayPlaceholder='DD'
                                monthPlaceholder='MM'
                                yearPlaceholder='YYYY'
                            />
                        </FormControl>
                        </Grid>
                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}>{t("By Screen")}</p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={pageOptions}
                                  value={selectedPage || defaultFilter}
                                  onChange={handlePageChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>

                            <p style={mb}>{t("By Change")}</p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={byChangeOptions}
                                  value={selectedByChange}
                                  onChange={handleByChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>

                        </Grid>
                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}>{t("By User")}</p>
                            {/* <FormControl className='default-search' sx={dropDownlistCss}>
                              <Select
                                className='autocomplete'
                                value={byName}
                                onChange={handleByNameChange}
                                isClearable={true}
                                options={userList}
                                placeholder={t("Select")}
                              />
                            </FormControl> */}
                            <FormControl className="default-search" sx={dropDownlistCss}>
                              <Select
                                className="autocomplete"
                                value={byName}
                                onChange={handleByNameChange}
                                onInputChange={handleInputChange} // Capture user input for search term
                                options={userList?.map((user) => ({
                                  label: user.label,
                                  value: user.value,
                                }))}
                                isClearable={true}
                                placeholder={t('Search')}
                                noOptionsMessage={() => (t('No options'))}
                              />
                            </FormControl>
                        </Grid>
                        <Grid
                            item
                            xs={12} lg={1} md={2} xl={1} sm={2}
                        >
                            <FormControl sx={dropDownlistCss} className="filter-btn">
                                <Styled.PrimaryButton type="submit">
                                    {t("Apply")}
                                </Styled.PrimaryButton>

                            </FormControl>
                        </Grid>

                        <Grid
                            item
                            xs={12} lg={1} md={2} xl={1} sm={2}
                            style={{paddingLeft: "10px"}}
                        >
                            <FormControl sx={dropDownlistCss} className="filter-btn">

                                <Styled.CancelButton  sx={{padding:'5px'}} onClick={() => { onClear() }} >
                                    {t("Clear")} 
                                </Styled.CancelButton>
                            </FormControl>
                        </Grid>
                        

                    </Grid>
                </form>
        )} 
            </div>
            {/* <Grid
              item
              xs={12} lg={2.5} md={8} xl={2.5}
              sx={gridItemCss}
              style={{display:'flex',alignItems:'end', flexDirection: 'column',paddingRight: 0, maxWidth: '100%'}}
              id="charityTable"
          >
              <p style={mb}></p>
              <div style={{position: 'relative', top: '-8px'}} className='search-table'> 
              <TextField
                  placeholder={"Charity and Activity name"} value={searchText} 
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }} sx={
                    {
                      '& .MuiInputBase-input': {
                        backgroundColor: '#fcfcfb',
                        fontSize: 14,
                        padding: "7px",
                        paddingLeft: "15px",
                        height: "38px",
                        minWidth: 'unset',
                        border: "1px solid #005974",
                        borderRadius: "5px 0 0 5px",
                        outline: "none",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        boxSizing: 'border-box'
                      }
                    }
                  }
                />
                  {searchText?.length > 0 ? <ClearIcon onClick={()=>{handleSearch('');}} fontSize="small" sx={{ position: 'absolute', right: 80, top: 8, color: appConfig.colors.blueprimary }} /> : null}

                  <Styled.CancelButton
                    style={{ ...SearchButtonStyle }}
                    variant="contained"
                    onClick={() => handleSearch(searchText.trim())}
                  >
                    <SearchIcon />
                  </Styled.CancelButton>
                </div> 
          </Grid> */}
      { auditLogDetails?.isLoading ? <SkeletonGridLoader />
        :
        <DefaultTable
        headers={headers}
        handlePagination={handlePagination}
        currentPage={pagination.offset}
        currentLimit={pagination.limit}
        totalCount={auditLogDetails?.count}
        isFilterOpen={isFilterOpen}
        data={auditTableData}
        accessor={accessor}
        sortValue={{ sortBy: 'col1', sortOrder: 'asc' }}
        hasDetails={true}
        loadRowDetails={loadRowDetails}
    />
  }
      </div>
  );
}

const mapStateToProps = (state) => ({ 
  auditLogDetails: state.auditLog.auditLog,
  auditUserList: state.auditLog.auditUserList
  })

const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
        fetchAuditLogList: (limit, offset, filter, search) => dispatch(auditActions.fetchAuditLogList(limit, offset, filter, search)),
        fetchAuditUserList: (search) => dispatch(auditActions.fetchAuditUserList(search))
    };
};
AuditLog.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
    fetchAuditLogList: PropTypes.func.isRequired,
    fetchAuditUserList: PropTypes.func.isRequired,
    auditLogDetails: PropTypes.object.isRequired,
    auditUserList: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditLog);

